<!-- Featured Blog Hero with Standard Gradient -->
<div class="relative bg-gradient-to-br from-gray-900 to-blue-900 text-white overflow-hidden">
  <div class="absolute inset-0 bg-pattern opacity-20"></div>
  <div class="absolute inset-0">
    <img [src]="featuredPosts[0]?.featuredImage" alt="Featured Blog" class="w-full h-full object-cover mix-blend-overlay opacity-30">
  </div>
  <div class="max-w-7xl mx-auto">
    <div class="relative z-10 py-12 lg:py-16">
      <div class="mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div class="sm:text-center lg:text-left">
            <div class="animate-fade-in-up">
              <div class="inline-flex items-center space-x-2 px-3 py-1 rounded-full bg-white/15 backdrop-blur-sm text-sm font-medium mb-4">
                <span class="w-2 h-2 rounded-full bg-blue-400 animate-pulse"></span>
                <span>Featured Article</span>
              </div>
              <h1 class="mt-4 text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
                {{ featuredPosts[0]?.title }}
              </h1>
              <p class="mt-4 text-lg text-white/80 sm:max-w-xl">
                {{ featuredPosts[0]?.excerpt }}
              </p>
              <div class="mt-6">
                <a [routerLink]="['/blog', featuredPosts[0]?.slug]" class="group inline-flex items-center px-6 py-3 rounded-full bg-blue-600 hover:bg-blue-700 text-white font-medium text-lg transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl">
                  Read Featured Article
                  <svg class="ml-3 w-5 h-5 transition-transform duration-200 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div class="mt-8 lg:mt-0 animate-fade-in-up">
            <div class="relative rounded-2xl shadow-2xl overflow-hidden transform hover:scale-105 transition-all duration-300 group">
              <img [src]="featuredPosts[0]?.featuredImage" alt="Featured Blog" class="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-110">
              <div class="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
              <div class="absolute bottom-4 left-4 right-4 text-white">
                <div class="flex items-center space-x-3">
                  <div class="h-8 w-8 rounded-full bg-blue-600/80 flex items-center justify-center text-white font-bold border border-white/20">
                    {{ (featuredPosts[0]?.author || 'A').charAt(0) }}
                  </div>
                  <div>
                    <p class="font-medium text-sm">{{ featuredPosts[0]?.author || 'Anonymous' }}</p>
                    <p class="text-xs text-white/70">{{ featuredPosts[0]?.publishDate | date:'mediumDate' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Blog Filtering Section with Interactive Search -->
<div class="bg-gray-50 py-12 border-b border-gray-200">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <!-- Category Pills -->
    <div class="mb-8">
      <div class="flex flex-wrap gap-2">
        <button *ngFor="let category of categories"
                (click)="filterByCategory(category)"
                [class.active]="selectedCategory === category">
          {{ category }}
        </button>
      </div>
    </div>

    <!-- Search Bar with Suggestions -->
    <div class="relative max-w-2xl mx-auto">
      <div class="relative">
        <input type="text" 
               [(ngModel)]="searchQuery"
               (input)="onSearch()"
               class="w-full px-6 py-4 text-lg border-2 border-gray-200 rounded-2xl bg-white placeholder-gray-400 focus:outline-none focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all duration-200"
               placeholder="Search articles by title, author, or topic...">
        <div class="absolute inset-y-0 right-0 flex items-center pr-4">
          <span class="inline-flex items-center gap-2 px-3 py-1 text-xs text-gray-500 bg-gray-100 rounded-full">
            Press <kbd class="px-2 py-1 bg-white rounded-md shadow">⏎</kbd>
          </span>
        </div>
      </div>

      <!-- Search Results Count -->
      <div *ngIf="filteredPosts.length > 0">
        Found {{ filteredPosts.length }} results
        <button (click)="clearCategoryFilter()"
                class="clear-filter">
          Clear Filters
        </button>
      </div>
    </div>

    <!-- Active Filters -->
    <div *ngIf="selectedCategory || searchQuery" 
         class="mt-4 flex items-center justify-center gap-2">
      <span class="text-sm text-gray-500">Active filters:</span>
      <div *ngIf="selectedCategory" 
           class="inline-flex items-center px-3 py-1 rounded-full text-sm bg-purple-100 text-purple-700">
        {{ selectedCategory }}
        <button (click)="clearCategoryFilter()" 
                class="ml-2 text-purple-500 hover:text-purple-700">
          ×
        </button>
      </div>
      <div *ngIf="searchQuery" 
           class="inline-flex items-center px-3 py-1 rounded-full text-sm bg-gray-100 text-gray-700">
        "{{ searchQuery }}"
        <button (click)="clearSearch()" 
                class="ml-2 text-gray-500 hover:text-gray-700">
          ×
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Blog Grid -->
<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
    <div *ngFor="let post of paginatedPosts" 
         class="blog-card group">
      <a [routerLink]="['/blog', post.slug]" class="block">
        <div class="relative overflow-hidden rounded-xl mb-4">
          <img [src]="post.featuredImage" 
               [alt]="post.title"
               class="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110">
          <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          <div class="absolute bottom-4 left-4">
            <span class="px-3 py-1 bg-purple-600 text-white text-sm rounded-full">
              {{ post.category }}
            </span>
          </div>
        </div>
        <h3 class="text-xl font-semibold text-gray-900 mb-2 group-hover:text-purple-600 transition-colors">
          {{ post.title }}
        </h3>
        <p class="text-gray-600 mb-4 line-clamp-2">{{ post.excerpt }}</p>
        <div class="flex items-center text-sm text-gray-500">
          <span>{{ post.author }}</span>
          <span class="mx-2">•</span>
          <span>{{ post.publishDate | date:'mediumDate' }}</span>
        </div>
      </a>
    </div>
  </div>

  <!-- Pagination -->
  <div *ngIf="filteredPosts.length > 0" class="mt-12 flex justify-between items-center">
    <button (click)="previousPage()" 
            [disabled]="currentPage === 1"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
      Previous
    </button>
    <span class="text-sm text-gray-600">
      Page {{ currentPage }} of {{ totalPages }}
    </span>
    <button (click)="nextPage()" 
            [disabled]="currentPage === totalPages"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
      Next
    </button>
  </div>

  <!-- No Results -->
  <div *ngIf="filteredPosts.length === 0" class="text-center py-12">
    <p class="text-gray-500 text-lg">No matching articles found.</p>
    <button (click)="clearCategoryFilter()"
            class="reset-button">
      Reset Filters
    </button>
  </div>
</div>

<!-- Client Testimonials with Interactive Logos -->
<div class="bg-gray-50 py-16">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="text-center mb-12">
      <span class="inline-block px-4 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-700">Our Clients</span>
      <h2 class="mt-4 text-3xl font-bold text-gray-900 sm:text-4xl">
        Trusted by Industry Leaders
      </h2>
    </div>
    <div class="grid grid-cols-2 gap-8 md:grid-cols-6 lg:grid-cols-6">
      <div *ngFor="let i of [1,2,3,4,5,6]" 
           class="col-span-1 flex justify-center filter grayscale hover:grayscale-0 transition-all duration-300 transform hover:scale-110">
        <img class="h-12" [src]="'assets/images/clients/client-' + i + '.svg'" [alt]="'Client ' + i">
      </div>
    </div>
  </div>
</div>

<!-- Bottom CTA with Interactive Elements -->
<div class="relative bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-800 overflow-hidden">
  <div class="absolute inset-0 bg-pattern opacity-10"></div>
  <div class="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8 relative z-10">
    <div class="lg:grid lg:grid-cols-2 lg:gap-12 items-center">
      <div>
        <h2 class="text-3xl font-extrabold text-white sm:text-4xl">
          Transform Your Business Intelligence
        </h2>
        <p class="mt-4 text-lg text-purple-100">
          Join industry leaders who trust our platform for real-time market insights and competitive analysis.
        </p>
        <div class="mt-8">
          <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div *ngFor="let feature of ['Real-time Market Data', 'AI-Powered Analytics', 'Competitive Intelligence', '24/7 Expert Support']"
                 class="group flex items-start space-x-3 p-4 rounded-xl hover:bg-white/10 transition-colors duration-200 cursor-pointer">
              <div class="flex-shrink-0">
                <div class="h-8 w-8 rounded-lg bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center transform group-hover:scale-110 transition-transform duration-200">
                  <svg class="h-5 w-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                </div>
              </div>
              <p class="text-purple-100 group-hover:text-white transition-colors duration-200">{{ feature }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-12 lg:mt-0">
        <div class="bg-white rounded-2xl shadow-xl p-8 transform hover:scale-105 transition-transform duration-300">
          <div class="space-y-6">
            <h3 class="text-2xl font-bold text-gray-900">Get Started Today</h3>
            <p class="text-gray-600">Schedule a demo to see how we can transform your business intelligence.</p>
            <div class="space-y-4">
              <button class="w-full inline-flex items-center justify-center px-8 py-4 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-medium text-lg hover:from-purple-700 hover:to-pink-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl">
                Schedule Demo
                <svg class="ml-2 -mr-1 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
                </svg>
              </button>
              <button class="w-full inline-flex items-center justify-center px-8 py-4 rounded-xl border-2 border-purple-200 text-purple-700 font-medium hover:bg-purple-50 transition-all duration-200">
                Watch Video Overview
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 